import { useIsMobile } from 'src/hooks/useIsMobile'
import { CuiButton } from 'front-lib'
import { OnboardingStepProps } from './OnboardingStep'
import { ReactComponent as ChevronRightIcon } from 'src/assets/icons/chevron-right.svg'

export function OnboardingStepCta({
  action
}: Readonly<{
  action: OnboardingStepProps['action']
}>) {
  const isMobile = useIsMobile()

  if (!action) return null
  if (isMobile) return <ChevronRightIcon />

  return (
    <CuiButton
      onClick={action.onClick}
      className="onboarding-step__action"
      size="large"
      style={{ whiteSpace: 'nowrap' }}>
      {action.label}
      {action.icon !== false && <ChevronRightIcon />}
    </CuiButton>
  )
}
